import { Component, OnInit, ElementRef } from '@angular/core';
import { EventManager } from '../../../node_modules/@angular/platform-browser';
import { ProjectService } from '../project.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {

  public keypadValue = "";
  public projectIdValue = "";

  constructor(
    public projectService: ProjectService
  ) {
  }


  ngOnInit() {
    if (localStorage.getItem("projects") != null) {
      this.projectService.Projects = JSON.parse(localStorage.getItem("projects")).filter((v, i, a) => a.indexOf(v) === i);
      var obj = {};

      for (var i = 0, len = this.projectService.Projects.length; i < len; i++) {
        obj[this.projectService.Projects[i]['place']] = this.projectService.Projects[i];
      }

      this.projectService.Projects = new Array();
      for (var key in obj)
        this.projectService.Projects.push(obj[key]);
    }
  }

  updateKeypadValue() {
    var o: any = document.getElementById("txtKeypadValue");
    this.keypadValue = o.value;
    this.projectService.getProjectInformation(this.keypadValue);
  }

  updateProjectIdValue() {
    var o: any = document.getElementById("txtProjectIdValue");
    this.projectIdValue = o.value;
    this.projectService.getProject(this.projectIdValue);
  }

  trackProject(index: number, data: any) {
    return data.Name;
  }
}